import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { GlobalErrorHandler } from './error-handlers/error.handler';
import { FacebookInterceptor } from './interceptors/facebook.interceptor';
import { OnboardingCatalogsGuard } from '@fb-tool-front/catalogs/guards/onboarding-catalogs.guard';
import { OnboardingOverlaysStepperGuard } from '@fb-tool-front/catalogs/guards/onboarding-overlays-stepper.guard';
import { OnboardingOverlaysSecondGuard } from '@fb-tool-front/catalogs/guards/onboarding-overlays-second.guard';
import { OnboardingOverlaysThirdGuard } from '@fb-tool-front/catalogs/guards/onboarding-overlays-third.guard';
import { AuthGuard } from './guards/auth.guard';
import { AuthClientGuard } from './guards/auth-client.guard';
import { LoginGuard } from './guards/login.guard';
import { ConfirmUserGuard } from './guards/confirm-user.guard';
import { ResetPasswordGuard } from './guards/reset-password-user.guard';
import { CorsInterceptor } from './interceptors/cors.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ImpersonateInterceptor } from './interceptors/impersonate.interceptor';
import { FacebookAuthGuard } from './guards/facebook-auth.guard';
import { ShowStatisticsGuard } from '@fb-tool-front/core/guards/show-statistics.guard';

export const throwIfAlreadyLoaded = (parentModule: any, moduleName: string): void => {
  if (parentModule) {
    throw new Error(
      `${moduleName} has already been loaded. Import Core modules in the AppModule only.`
    );
  }
};

@NgModule({
  imports: [CommonModule, HttpClientModule],
  providers: [
    AuthGuard,
    AuthClientGuard,
    LoginGuard,
    ShowStatisticsGuard,
    OnboardingCatalogsGuard,
    OnboardingOverlaysStepperGuard,
    OnboardingOverlaysSecondGuard,
    OnboardingOverlaysThirdGuard,
    ConfirmUserGuard,
    ResetPasswordGuard,
    FacebookAuthGuard,
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CorsInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FacebookInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ImpersonateInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
